import { AllocationViewActionIdentifierModel } from '../../models';

export class AllocationViewTruckLeftAction {
  public static readonly type = '[AllocationViewTruckLeftAction] Truck Left';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewTruckLeftActionSetInitialState {
  public static readonly type = '[AllocationViewTruckLeftAction] Set Initial State';
}
